<template>
  <div>
    <div class="form-group">
      <div>環境確認項目</div>
      <div class="row">
        <div class="col-sm-4">
          <b-form-checkbox
            id="kitchen"
            v-model="kitchen"
            name="kitchen"
            value="true"
            unchecked-value="false"
          >
            廚房
          </b-form-checkbox>
        </div>
        <div class="col-sm-4">
          <b-form-checkbox
            id="living_room"
            v-model="living_room"
            name="living_room"
            value="true"
            unchecked-value="false"
          >
            客廳
          </b-form-checkbox>
        </div>
        <div class="col-sm-4">
          <b-form-checkbox
            id="bedroom"
            v-model="bedroom"
            name="bedroom"
            value="true"
            unchecked-value="false"
          >
            臥室
          </b-form-checkbox>
        </div>
        <div class="col-sm-4">
          <b-form-checkbox
            id="bathroom"
            v-model="bathroom"
            name="bathroom"
            value="true"
            unchecked-value="false"
          >
            浴室
          </b-form-checkbox>
        </div>
        <div class="col-sm-4">
          <b-form-checkbox
            id="balcony"
            v-model="balcony"
            name="balcony"
            value="true"
            unchecked-value="false"
          >
            陽台
          </b-form-checkbox>
        </div>
        <div class="col-sm-4">
          <b-form-checkbox
            id="entrance"
            v-model="entrance"
            name="entrance"
            value="true"
            unchecked-value="false"
          >
            玄關
          </b-form-checkbox>
        </div>
        <hr>
        <div class="col-sm-12">
          <b-form-group label="特殊方案:" class="text-left">
            <b-form-select
              v-model="order_type"
              :options="spTypeArray"
              value-field="value"
              text-field="name"
              :disabled="(houseCheckInfo.specified_max_cash_time || houseCheckInfo.specified_cash) ? true : false"
            >
            </b-form-select>
          </b-form-group>
        </div>
        <div class="col-sm-12">
          <b-form-group label="客戶類型:" class="text-left">
            <b-form-select
              v-model="user_type"
              :options="orderTypeArray"
              value-field="value"
              text-field="name"
              :disabled="(houseCheckInfo.specified_max_cash_time || houseCheckInfo.specified_cash) ? true : false"
            >
            </b-form-select>
          </b-form-group>
        </div>
        <div class="col-sm-12" v-if="order_type">
          <b-form-group
            id="edit-group-name"
            label="服務金額:"
            label-for="force_price"
          >
            <b-form-input
              id="force_price"
              v-model="force_price"
              type="number"
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="row col-sm-12" v-if="houseCheckInfo.specified_cash">
          <div class="col-sm-4 order-info-label-sty">預算上限金額</div>
          <div class="col-sm-8">{{ houseCheckInfo.specified_cash }} 元</div>
        </div>
        <div class="row col-sm-12"  v-if="houseCheckInfo.specified_max_cash_time">
          <div class="col-sm-4 order-info-label-sty">預算上限時數</div>
          <div class="col-sm-8">{{ houseCheckInfo.specified_max_cash_time }} 小時</div>
        </div>
    </div>
    </div>
    <b-form-group label="付款方式">
      <b-form-radio-group
        id="radio-group-payment"
        v-model="payment"
        name="radio-payments"
      >
        <b-form-radio value="1">現金付款</b-form-radio>
        <b-form-radio value="2">匯款</b-form-radio>
        <b-form-radio value="3">使用儲值金</b-form-radio>
      </b-form-radio-group>
    </b-form-group>
    <div class="form-group">
      <label for="note">額外備註</label>
      <b-form-textarea
        id="note"
        v-model="note"
        rows="5"
        lazy-formatter
        max-rows="10"
      ></b-form-textarea>
    </div>
  </div>
</template>
<script>
export default {
  name: 'HouseCheckList',
  props: {
    houseCheckInfo: Object,
    actionType: String,
    userType: Number,
    orderCounts: Number,
    freeHourTotal: Number,
    userTransferplanCash: Number
  },
  data () {
    return {
      kitchen: this.houseCheckInfo.kitchen,
      living_room: this.houseCheckInfo.living_room,
      bedroom: this.houseCheckInfo.bedroom,
      bathroom: this.houseCheckInfo.bathroom,
      balcony: this.houseCheckInfo.balcony,
      entrance: this.houseCheckInfo.entrance,
      note: this.houseCheckInfo.note,
      // free_trial: false,
      force_price: this.houseCheckInfo.force_price,
      payment: this.houseCheckInfo.payment, // 1. 現金, 2. 匯款, 3.使用儲值金
      // frontend data start from this line
      order_type: this.houseCheckInfo.order_type,
      user_type: this.houseCheckInfo.user_type, // 1. 一般, 2.VIP
      orderTypeArray: [
        {
          value: 1,
          name: '一般'
        },
        {
          value: 2,
          name: '貴賓'
        // },
        // {
        //   value: 3,
        //   name: 'VIP'
        }
      ],
      spTypeArray: [
        {
          value: 1,
          name: '無'
        },
        {
          value: 2,
          name: '服務體驗'
        },
        {
          value: 3,
          name: '首小時優惠'
        }
      ]
    }
  },
  created () {
    this.$nextTick(() => {
      console.log('this.houseCheckInfo', this.houseCheckInfo)
      // console.log('this.$parent.houseCheckInfo', this.$parent.houseCheckInfo)
      // console.log('freeHourTotal', this.freeHourTotal)
      if (this.houseCheckInfo.specified_cash || this.houseCheckInfo.specified_max_cash_time) {
        this.order_type = 1
      } else {
        console.log('orderType', this.order_type)
        if (this.order_type === 1 || this.order_type === 0) {
          if (this.freeHourTotal && this.freeHourTotal > 0) {
            this.order_type = 3
          }
        }
      }
      if (!this.houseCheckInfo.payment) {
        this.payment = this.userTransferplanCash > 0 ? 3 : 1
      }
    })
  },
  watch: {
    kitchen (val) {
      this.updateSingleVal('kitchen', val)
    },
    living_room (val) {
      this.updateSingleVal('living_room', val)
    },
    bedroom (val) {
      this.updateSingleVal('bedroom', val)
    },
    bathroom (val) {
      this.updateSingleVal('bathroom', val)
    },
    balcony (val) {
      this.updateSingleVal('balcony', val)
    },
    entrance (val) {
      this.updateSingleVal('entrance', val)
    }
  },
  methods: {
    updateSingleVal (type, val) {
      if (typeof val !== 'boolean') {
        val = this.$toolDoc.turnToBoolean(val)
      }
      this.$parent.houseCheckInfo[type] = val
    },
    updateVal () {
      this.$parent.houseCheckInfo.id = this.houseCheckInfo.id
      this.$parent.houseCheckInfo.kitchen = this.$toolDoc.turnToBoolean(this.kitchen)
      this.$parent.houseCheckInfo.living_room = this.$toolDoc.turnToBoolean(this.living_room)
      this.$parent.houseCheckInfo.bedroom = this.$toolDoc.turnToBoolean(this.bedroom)
      this.$parent.houseCheckInfo.bathroom = this.$toolDoc.turnToBoolean(this.bathroom)
      this.$parent.houseCheckInfo.balcony = this.$toolDoc.turnToBoolean(this.balcony)
      this.$parent.houseCheckInfo.entrance = this.$toolDoc.turnToBoolean(this.entrance)
      this.$parent.houseCheckInfo.note = this.note
      this.$parent.houseCheckInfo.force_price = this.$toolDoc.turnToNumber(this.force_price)
      this.$parent.houseCheckInfo.order_type = this.$toolDoc.turnToNumber(this.order_type)
      this.$parent.houseCheckInfo.user_type = this.$toolDoc.turnToNumber(this.user_type)
      this.$parent.orderInfo.payment = this.payment === 1 ? '現金' : '匯款'
    },
    initVal () {
      this.$parent.houseCheckInfo.id = this.houseCheckInfo.id
      this.$parent.houseCheckInfo.kitchen = this.houseCheckInfo.kitchen
      this.$parent.houseCheckInfo.living_room = this.houseCheckInfo.living_room
      this.$parent.houseCheckInfo.bedroom = this.houseCheckInfo.bedroom
      this.$parent.houseCheckInfo.bathroom = this.houseCheckInfo.bathroom
      this.$parent.houseCheckInfo.balcony = this.houseCheckInfo.balcony
      this.$parent.houseCheckInfo.entrance = this.houseCheckInfo.entrance
      this.$parent.houseCheckInfo.note = this.houseCheckInfo.note
      this.$parent.houseCheckInfo.force_price = this.houseCheckInfo.force_price
      this.$parent.houseCheckInfo.order_type = this.houseCheckInfo.order_type
    },
    submitHouseForm () {
      const self = this
      var houselistUrl = this.$parent.baseUrl + this.$parent.userId + this.$apiDoc.apiPostOrder + this.$parent.orderId + this.$apiDoc.apiGetHouseCheck
      // var finalUrl = (this.actionType === 'edit') ? houselistUrl + '/' + this.actionType : houselistUrl
      var options = {
        kitchen: this.$toolDoc.turnToBoolean(this.kitchen),
        living_room: this.$toolDoc.turnToBoolean(this.living_room),
        bedroom: this.$toolDoc.turnToBoolean(this.bedroom),
        bathroom: this.$toolDoc.turnToBoolean(this.bathroom),
        balcony: this.$toolDoc.turnToBoolean(this.balcony),
        entrance: this.$toolDoc.turnToBoolean(this.entrance),
        note: this.note,
        force_price: this.$toolDoc.turnToNumber(this.force_price),
        payment: this.$toolDoc.turnToNumber(this.payment),
        order_type: this.$toolDoc.turnToNumber(this.order_type),
        user_type: this.$toolDoc.turnToNumber(this.user_type),
        user_free_hour_total: this.freeHourTotal
      }
      var errorMsg
      this.$parent.$parent.isLoadShow = true
      if (this.actionType === 'edit') {
        this.$api.patch(houselistUrl, options).then((resp) => {
          if (resp.result) {
            self.updateVal()
          } else {
            self.initVal()
            if (resp.data) {
              errorMsg = resp.data
            }
            alert(errorMsg)
          }
          self.$parent.isStartCheck = false
          self.$parent.$parent.isLoadShow = false
          this.$liff.closeWindow()
        }).catch((errorInfo) => {
          errorMsg = self.$toolDoc.convertErrorMsg(errorInfo)
          alert(errorMsg)
          self.initVal()
          self.$parent.isStartCheck = false
          self.$parent.$parent.isLoadShow = false
          self.$liff.closeWindow()
        })
      } else {
        this.$api.post(houselistUrl, options).then((resp) => {
          if (resp.result) {
            self.updateVal()
          } else {
            self.initVal()
            if (resp.data) {
              errorMsg = resp.data
            }
            alert(errorMsg)
          }
          self.$parent.isStartCheck = false
          self.$parent.$parent.isLoadShow = false
          self.$liff.closeWindow()
        }).catch((errorInfo) => {
          errorMsg = self.$toolDoc.convertErrorMsg(errorInfo)
          alert(errorMsg)
          self.initVal()
          self.$parent.isStartCheck = false
          self.$parent.$parent.isLoadShow = false
          self.$liff.closeWindow()
        })
      }
    }
  },
  components: {
  }
}
</script>
